export default "__VITE_ASSET__QZf47u1v__"